import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const Heading = styled('h4')(({ theme }) => (props) => ({
    fontSize: '1.8vw',
    fontWeight: 800,
    lineHeight: '29px',
    letterSpacing: '0em',
    display: 'inline',
    margin: '0 10px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '2vw',

    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2.2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '20px',
    }
}))
export const TextLink = styled(Link)(({ theme }) => (props) => ({
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '17.7px',
    letterSpacing: '0em',
    color: '#0056D2',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    marginTop: '15px'
    , [theme.breakpoints.down('lg')]: {
        fontSize: '12px',
    }
    , [theme.breakpoints.down('md')]: {
        marginTop: '7px'
    }
}))